import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot, $isElementNode, $isTextNode } from "lexical";
import { $isTagNode } from "./TagNode";
import { $isOperatorNode } from "./OperatorNode";

interface OnChangePluginProps {
  onChange?: (value: string) => void;
}

export const OnChangePlugin: React.FC<OnChangePluginProps> = ({ onChange }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const root = $getRoot();
        let textContent = "";

        const traverse = (node: any) => {
          if ($isTagNode(node)) {
            textContent += node.getTextContent();
          } else if ($isOperatorNode(node)) {
            textContent += node.getTextContent();
          } else if ($isTextNode(node)) {
            textContent += node.getTextContent();
          } else if ($isElementNode(node)) {
            const children = node.getChildren();
            children.forEach(traverse);
          }
        };

        root.getChildren().forEach(traverse);

        // Convert ≠ to != for storage
        const convertedContent = textContent.replace(/≠/g, "!=");

        onChange?.(convertedContent);
      });
    });
  }, [editor, onChange]);

  return null;
};

